<div class="categories categories_sticky">
    <div class="category-item" *ngFor="let category of categorieList"
        [ngClass]="{'selected': selectedCategory === category.name}" (click)="selectCategory(category.name)">
        <img [src]="category.img" [alt]="category.label" class="category-img">
        {{ category.label }}
        <span class="selected-icon" *ngIf="selectedCategory === category.name">✔️</span>
    </div>
</div>

<!-- Products Section -->


<div *ngIf="selectedCategory && selectedCategory != 'customCakes'" class="products-wrapper">
    <div *ngIf="displayedProducts.length == 0" class="coming-soon-container">
        <div class="coming-soon-content">
            <h1>Coming Soon</h1>
            <p>Exciting products are on the way! Stay tuned.</p>
        </div>
    </div>
    <div *ngIf="displayedProducts.length > 0">
        <h3 class="h3_font_size" style="margin: 0px 10px;"
            *ngIf="selectedCategory && displayedProducts.length > 0 && selectedCategory != 'customCakes'">
            Products for {{selectedCategoryName }}
        </h3>
        <div class="products-list" *ngIf="displayedProducts.length > 0">
            <div *ngFor="let product of displayedProducts" class="product-item"
                [ngClass]="{'selected': selectedProduct === product}" (click)="openStorePickupDialog(product)">
                <div [ngClass]="selectedCategory == 'photoCakes' ? 'template-image-wrapper' : 'product-image-wrapper'">
                    <img src="../../../../assets/img/{{ product.product_Picture }}" alt="Image not found"
                        onerror="this.src='../../../../assets/img/defaultCake.webp';">
                    <img style="border-radius: 0px;"
                        *ngIf="product.food_Type == 'Veg' && product.customizeType != 'Photo Frames'"
                        class="img-responsive img_align" src="../../../../assets/img/Veg.webp" alt="" />
                    <img style="border-radius: 0px;"
                        *ngIf="product.food_Type == 'Non-Veg'  && product.customizeType != 'Photo Frames'"
                        class="img-responsive img_align" src="../../../../assets/img/Nonveg.webp" alt="" />

                    <img *ngIf="product.offers >= 1" class="img-responsive offer_align"
                        src="../../../../assets/img/Offer 1.webp" alt="" matTooltip="Offers" />
                    <span class="product-selected-icon" *ngIf="selectedProduct === product">✔️</span>
                </div>
                <p class="left_product_name">{{ product.product_Name }}</p>
            </div>
        </div>
    </div>

    <!-- Template Selection -->
    <div *ngIf="selectedProduct && selectedCategory == 'chocolate'" class="template-selection-container">
        <h3 class="h3_font_size" style="margin: 0px 10px;">Select Template</h3>
        <div class="template-list">
            <div *ngFor="let template of selectedProduct.templates" class="product-item"
                [ngClass]="{'selected': selectedTemplate === template}" (click)="selectTemplate(template)">
                <div class="template-image-wrapper">
                    <img [src]="'../../../../assets/img/' + template.preview" class="template-thumbnail">
                </div>
            </div>
        </div>
    </div>

    <!-- Template Preview -->
    <div *ngIf="selectedTemplate" class="template-preview-container">
        <div class="template-layout">

            <!-- Toggle button (NOT inside zoomable container) -->
            <button class="zoom-toggle-btn" (click)="toggleZoom()"
                [title]="zoomEnabled ? 'Disable Zoom' : 'Enable Zoom'">
                <mat-icon>{{ zoomEnabled ? 'zoom_out_map' : 'zoom_in_map' }}</mat-icon>
            </button>

            <!-- Zoomable container -->
            <div class="template-layout-box zoom-container" (mousemove)="zoomEnabled && onMouseMove($event)"
                (mouseleave)="zoomEnabled && onMouseLeave()" (touchstart)="zoomEnabled && onTouchStart($event)"
                (touchmove)="zoomEnabled && onTouchMove($event)" (touchend)="zoomEnabled && onMouseLeave()"
                [ngStyle]="zoomStyles" #zoomArea>

                <div class="left-template" #productImageContainer>
                    <div class="image-wrapper">
                        <img [src]="'../../../../assets/img/' + selectedTemplate.preview"
                            class="img-fluid rounded template-img template-base" alt="Template Preview" />

                        <div class="template-text top-text" [ngStyle]="getTopTextStyle()">
                            {{ textInputsTop[selectedOverlayIndex] }}
                        </div>

                        <div class="template-text bottom-text" [ngStyle]="getBottomTextStyle()">
                            {{ textInputsBottom[selectedOverlayIndex] }}
                        </div>

                        <!-- Center main overlay -->
                        <div *ngIf="getFileData('fileImage' + selectedOverlayIndex) && selectedProduct.customizeType == 'Chocolate'"
                            class="cake-overlay-wrapper" [ngStyle]="getStyleForImage(selectedOverlayIndex)">
                            <div class="cake-overlay-image" [class.circle]="isCircle">
                                <img [src]="getOverlayImage(selectedOverlayIndex)" alt="Overlay" />
                            </div>
                        </div>

                        <!-- Right small overlay (same image, new position) -->
                        <div *ngIf="getFileData('fileImage' + selectedOverlayIndex) && selectedProduct.customizeType == 'Chocolate'"
                            class="cake-overlay-wrapper" [ngStyle]="getStyleForRightImage(selectedOverlayIndex)">
                            <div class="cake-overlay-image" [class.circle]="isCircle">
                                <img [src]="getOverlayImage(selectedOverlayIndex)" alt="Overlay" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="right-images" *ngIf="selectedTemplate?.extras?.length">
                    <img *ngFor="let extra of selectedTemplate.extras" [src]="'../../../../assets/img/' + extra"
                        class="img-fluid extra-img" alt="Extra Image" />

                    <div class="template-text top-text-right" [ngStyle]="{ color: textColorTop[selectedOverlayIndex] || 'white',
                            fontFamily: textFontTop[selectedOverlayIndex] || 'Arial'}">
                        {{ textInputsTop[selectedOverlayIndex] }}
                    </div>

                    <div class="template-text bottom-text-right" [ngStyle]="{ color: textColorBottom[selectedOverlayIndex] || 'white',
                            fontFamily: textFontBottom[selectedOverlayIndex] || 'Arial'}">
                        {{ textInputsBottom[selectedOverlayIndex] }}
                    </div>

                    <div *ngIf="getFileData('fileImage' + selectedOverlayIndex) && selectedProduct.customizeType == 'Chocolate'"
                        class="cake-overlay-wrapper" [ngStyle]="getStyleForImageRight(selectedOverlayIndex)">
                        <div class="cake-overlay-image" [class.circle]="isCircle">
                            <img [src]="getOverlayImage(selectedOverlayIndex)" alt="Overlay" />
                        </div>
                    </div>

                    <div *ngIf="getFileData('fileImage' + selectedOverlayIndex) && selectedProduct.customizeType == 'Chocolate'"
                        class="cake-overlay-wrapper" [ngStyle]="getStyleForImageRightSmall(selectedOverlayIndex)">
                        <div class="cake-overlay-image" [class.circle]="isCircle">
                            <img [src]="getOverlayImage(selectedOverlayIndex)" alt="Overlay" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Textbox to type -->
        <div class="text-inputs">
            <!-- Top Text Input with Color Picker -->
            <mat-card class="contain_card mat-card_style4 card_margin" style="display: flex;">
                <mat-form-field class="example-full-width" style="width: 100%;">
                    <input matInput placeholder="Top Text" [(ngModel)]="textInputsTop[selectedOverlayIndex]"
                        maxlength="18" style="text-align: left;" />

                    <span matSuffix class="text_hint">
                        {{ textInputsTop[selectedOverlayIndex]?.length || 0 }}/18
                    </span>
                </mat-form-field>

                <div style="display: flex; align-items: center; gap: 10px;">
                    <select class="font-picker" id="topFont" [(ngModel)]="textFontTop[selectedOverlayIndex]">
                        <option value="" disabled>Select Style</option>
                        <option *ngFor="let font of availableFonts" [value]="font" [ngStyle]="{ 'font-family': font }">
                            {{ font }}
                        </option>
                    </select>

                    <input type="color" class="color-picker" [(ngModel)]="textColorTop[selectedOverlayIndex]" />
                </div>

            </mat-card>

            <!-- Bottom Text Input with Color Picker -->
            <mat-card class="contain_card mat-card_style4 card_margin" style="display: flex;">
                <mat-form-field class="example-full-width" style="width: 100%;">
                    <input matInput placeholder="Bottom Text" [(ngModel)]="textInputsBottom[selectedOverlayIndex]"
                        maxlength="18" style="text-align: left;" />

                    <span matSuffix class="text_hint">
                        {{ textInputsBottom[selectedOverlayIndex]?.length || 0 }}/18
                    </span>
                </mat-form-field>

                <div style="display: flex; align-items: center; gap: 10px;">
                    <select class="font-picker" [(ngModel)]="textFontBottom[selectedOverlayIndex]">
                        <option value="" disabled>Select Style</option>
                        <option *ngFor="let font of availableFonts" [value]="font" [ngStyle]="{ 'font-family': font }">
                            {{ font }}
                        </option>
                    </select>

                    <input type="color" class="color-picker" [(ngModel)]="textColorBottom[selectedOverlayIndex]" />
                </div>
            </mat-card>

        </div>

        <div class="text-center mt-2" *ngIf="getFileData('fileImage' + 0)">
            <span class="toggle-bg-text" (click)="toggleImageVersion(selectedOverlayIndex)">
                {{ useProcessedImage[selectedOverlayIndex] ? 'Back to Original' : 'Remove Background' }}
            </span>
        </div>

        <!-- Uploaded user image -->
        <div class="file_select_div_chocolate">
            <input type="file" readonly (change)="onChangeUploadFile($event, 'fileImage' + 0, 'image' + 0)"
                accept=".jpg,.jpeg,.png,.webp" (click)="$any($event.target).value=null" class="hidden-file-input"
                [id]="'image' + 0">

            <button class="chocolate-file-button" (click)="triggerFileInput('image' + 0)">
                Choose File
            </button>

            <span *ngIf="files['fileImage' + 0]" class="file_name_span">
                {{ files['fileImage' + 0].name }}
            </span>

            <mat-icon class="cancel_icon_chocolate" *ngIf="getFileData('fileImage' + 0)"
                (click)="onRemoveFileClick('fileImage' + 0, 'image' + 0);">
                clear
            </mat-icon>
        </div>
        <div class="file-format-note">
            Only JPG, JPEG, PNG, WEBP formats are accepted. (Max 10MB)
        </div>

        <div class="terms_div" style="padding: 0px 28px;">
            <label class="checkbox">
                <input type="checkbox" style="height: 20px; width: 15px" [(ngModel)]="isAgreedTermsPhoto"
                    [disabled]="isAgreedTermsPhoto" />
                I acknowledge and agree that the actual cake product may vary from the online image due to
                manual customization and edible printing processes.
            </label>
        </div>

        <p [innerHTML]="descStr" class="description" style="padding: 0px 16px;"></p>

        <div class="product-detail">
            <form [formGroup]="createSetUpForm">
                <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div">
                    <mat-card class="contain_card mat-card_style2 card_margin">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput placeholder="Price/{{ selectedProduct.product_Unit }}"
                                formControlName="productPrice"
                                [value]="createSetUpForm.get('productPrice').value | number: '1.2-2'" readonly
                                style="text-align: left; padding-bottom: 2%" />
                        </mat-form-field>
                    </mat-card>

                    <mat-card class="contain_card mat-card_style2 card_margin">
                        <mat-form-field class="example-full-width" style="width: 100%;">
                            <mat-label>
                                Quantity/{{selectedProduct.product_Unit}}&nbsp;
                                <mat-icon
                                    matTooltip="Quantity must be in multiples of {{selectedProduct.retail_Rol}} starting from {{minimumQty}}"
                                    matTooltipTouchGestures="on" tabindex="0"
                                    style="cursor: pointer; pointer-events: auto;">
                                    info
                                </mat-icon>

                            </mat-label>
                            <input matInput type="number" formControlName="qty" (focusout)="onQtySelect($event)"
                                style="text-align: left;" />

                            <button type="button" mat-icon-button matSuffix color="accent" (click)="decreaseQty()">
                                <mat-icon class="qty_change_icon">remove</mat-icon>
                            </button>

                            <button type="button" mat-icon-button matSuffix color="primary" (click)="increaseQty()"
                                style="margin: 4px;">
                                <mat-icon class="qty_change_icon">add</mat-icon>
                            </button>
                        </mat-form-field>
                    </mat-card>
                </div>

                <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div">
                    <mat-card class="contain_card mat-card_style2 card_margin">
                        <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                            <input matInput placeholder="Delivery Date" [matDatepicker]="licker1" [min]="todayDate"
                                [max]="maxDate" formControlName="deliveryDate" (click)="licker1.open()"
                                (dateChange)="dateChanged()" style="text-align: left; padding-bottom: 2%" readonly />
                            <mat-datepicker-toggle matSuffix [for]="licker1"></mat-datepicker-toggle>
                            <mat-datepicker #licker1 disabled="false"></mat-datepicker>
                        </mat-form-field>
                    </mat-card>

                    <mat-card class="contain_card mat-card_style2 card_margin">
                        <mat-form-field class="selectOption" style="width: 100%" visivility="none">
                            <mat-select placeholder="Delivery Time Slot" formControlName="deliveryTime">
                                <mat-option style="text-align: left; padding-bottom: 2%"
                                    *ngFor="let slot of timeSlotAvl" [value]="slot">
                                    {{ slot }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-card>
                </div>

                <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div">
                    <mat-card class="contain_card mat-card_style card_margin">
                        <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                            <input matInput placeholder="SubTotal" formControlName="subTotal"
                                [value]="createSetUpForm.get('subTotal').value | number: '1.2-2'"
                                style="text-align: left; padding-bottom: 2%" readonly />
                        </mat-form-field>
                    </mat-card>
                </div>

                <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div_btn">
                    <button type="button" class="btn btn-primary bg-pink" (click)="addToCart(selectedProduct, false)">
                        Add to Cart
                    </button>
                    <button type="button" class="btn btn-primary bg-pink" (click)="addToCart(selectedProduct, true)">
                        Buy Now
                    </button>
                </div>
            </form>
        </div>
    </div>

    <!-- Product Details Section -->
    <div class="container details_container" *ngIf="selectedProduct && selectedCategory != 'chocolate'">
        <div class="row" style="display: flex;justify-content: center;">
            <div class="col-sm-4">
                <h1 class="mbr-section-title h2_font_size">{{ selectedProduct.product_Name }}</h1>

                <div class="product-image">
                    <div class="view hm-zoom z-depth-2" id="img_div_align" #productImageContainer>

                        <!-- Product image -->
                        <img src="../../../../assets/img/{{ selectedProduct.product_Picture }}" alt="Image not found"
                            class="img-fluid rounded" style="height: 100%"
                            onerror="this.src='../../../../assets/img/defaultCake.webp';" />

                        <!-- Dynamic center image (Photo Cake Mini / Medium / Large) -->
                        <div *ngIf="getFileData('fileImage' + selectedOverlayIndex) &&
                                    (customizePhotoCakes.includes(selectedProduct.product_Code) && 
                                    selectedProduct.customizeType == 'Photo Cakes') && !['Photo Gallery Cake'].includes(selectedProduct.product_Name)"
                            class="cake-overlay-wrapper" [ngStyle]="getStyleForImage(selectedOverlayIndex)">
                            <div class="cake-overlay-image" [class.circle]="isCircle">
                                <img [src]="getFileData('fileImage' + selectedOverlayIndex)" alt="Overlay" />
                            </div>
                        </div>

                        <!-- Dynamic center image (Photo Frames) -->
                        <div *ngIf="getFileData('fileImage' + selectedOverlayIndex) &&
                         (customizePhotoCakes.includes(selectedProduct.product_Code) && selectedProduct.customizeType == 'Photo Frames')"
                            class="cake-overlay-wrapper" [ngStyle]="getStyleForImage(selectedOverlayIndex)">
                            <div class="cake-overlay-image" [class.circle]="isCircle">
                                <img [src]="getOverlayImage(selectedOverlayIndex)" alt="Overlay" />
                            </div>
                        </div>

                        <!-- Center round image (Photo Gallery Cake) -->
                        <div *ngIf="getFileData('fileImage0') &&
                                    ['Photo Gallery Cake'].includes(selectedProduct.product_Name)"
                            class="cake-fixed-overlay-wrapper cake-center-circle">
                            <div class="cake-fixed-overlay-image">
                                <img [src]="getFileData('fileImage0')" alt="Bottom Round Image" />
                            </div>
                        </div>

                        <!-- Top 3 garland square images -->
                        <ng-container *ngIf="['Photo Gallery Cake'].includes(selectedProduct?.product_Name)">
                            <ng-container *ngFor="let idx of [1, 2, 3]; let i = index">
                                <div *ngIf="getFileData('fileImage' + idx)"
                                    class="cake-fixed-overlay-wrapper cake-top-garland" [ngStyle]="getFixedTopStyle(i)">
                                    <div class="cake-fixed-overlay-image">
                                        <img [src]="getFileData('fileImage' + idx)" alt="Top Garland Image" />
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>

                        <ng-container *ngIf="selectedProduct?.product_Name === 'Photo Circle'">
                            <!-- Top 4 round images -->
                            <ng-container *ngFor="let idx of [0, 1, 2, 3]; let i = index">
                                <div *ngIf="getFileData('fileImage' + idx)" class="photo-circle-top-image-wrapper"
                                    [ngStyle]="getPhotoCircleTopStyle(i)">
                                    <div class="photo-circle-top-image circle">
                                        <img [src]="getFileData('fileImage' + idx)" alt="Top Round Image" />
                                    </div>
                                </div>
                            </ng-container>

                            <!-- Middle 4 square images - wrapped in a 3D container -->
                            <div class="photo-circle-middle-band">
                                <ng-container *ngFor="let idx of [0, 1, 2, 3]; let i = index">
                                    <div *ngIf="getFileData('fileImage' + idx)"
                                        class="photo-circle-middle-image-wrapper"
                                        [ngStyle]="getPhotoCircleMiddleStyle(i)">
                                        <div class="photo-circle-middle-image">
                                            <img [src]="getFileData('fileImage' + idx)" alt="Middle Square Image"
                                                [ngClass]="{
                                                'photo-radius-left-bottom': i === 1,
                                                'photo-radius-right-bottom': i === 2,
                                                'photo-radius-right-bottom-left-top': i === 3
                                              }" />
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>

                        <!-- Circle overlay -->
                        <div *ngIf="createSetUpForm.get('noteTop')?.value?.length || createSetUpForm.get('noteCenter')?.value?.length || createSetUpForm.get('noteBottom')?.value?.length"
                            class="overlay-circle-wrapper" (click)="isZoomed = !isZoomed" [class.zoomed]="isZoomed"
                            [style.cursor]="isZoomed ? 'zoom-out' : 'zoom-in'">
                            <svg viewBox="0 0 200 200" class="circle-svg">
                                <!-- Thicker border circle -->
                                <circle cx="100" cy="100" r="90" fill="rgba(255,255,255,0.7)" stroke="black"
                                    stroke-width="6" />

                                <defs>
                                    <!-- Top curve -->
                                    <path id="topPath" d="M 30,100 A 70,70 0 0 1 170,100" />
                                    <!-- Bottom curve (flipped) -->
                                    <path id="bottomPath" d="M 30,100 A 70,70 0 0 0 170,100" />
                                </defs>

                                <!-- Top text -->
                                <text font-size="20" fill="#000" font-weight="bold" dy="5">
                                    <textPath href="#topPath" startOffset="50%" text-anchor="middle">
                                        {{ createSetUpForm.get('noteTop')?.value }}
                                    </textPath>
                                </text>

                                <!-- Center text -->
                                <text x="100" y="105" text-anchor="middle" font-size="20" fill="#000"
                                    font-weight="bold">
                                    {{ createSetUpForm.get('noteCenter')?.value }}
                                </text>

                                <!-- Bottom text -->
                                <text font-size="20" fill="#000" font-weight="bold" dy="5">
                                    <textPath href="#bottomPath" startOffset="50%" text-anchor="middle">
                                        {{ createSetUpForm.get('noteBottom')?.value }}
                                    </textPath>
                                </text>
                            </svg>
                        </div>

                        <!-- Extra UI elements unchanged -->
                        <span *ngIf="(selectedProduct.customizeType != 'Photo Frames')"
                            style="position: absolute; top: 6%; right: 5%;">
                            <img *ngIf="selectedProduct.food_Type == 'Veg'" style="width: 17px; height: 17px"
                                src="../../../../assets/img/Veg.webp" />
                            <img *ngIf="selectedProduct.food_Type == 'Non-Veg'" style="width: 17px; height: 17px"
                                src="../../../../assets/img/Nonveg.webp" />
                        </span>
                        <span style="cursor: pointer;">
                            <img *ngIf="selectedProduct.offers >= 1" class="img-responsive offer_align_product"
                                src="../../../../assets/img/Offer 1.webp"
                                (click)="viewOfferDetail(selectedProduct.offerDetails)" matTooltip="Offers" />
                        </span>
                    </div>

                    <!-- Remove/Back Text Toggle -->
                    <!-- <div class="text-center mt-2">
                        <span class="toggle-bg-text" (click)="toggleImageVersion(selectedOverlayIndex)">
                            {{ useProcessedImage[selectedOverlayIndex] ? 'Back to Original' : 'Remove Background' }}
                        </span>
                    </div> -->
                </div>

                <div class="terms_div">
                    <label class="checkbox">
                        <input type="checkbox" style="height: 20px; width: 15px" [(ngModel)]="isAgreedTermsPhoto"
                            [disabled]="isAgreedTermsPhoto" />
                        I acknowledge and agree that the actual cake product may vary from the online image due to
                        manual customization and edible printing processes.
                    </label>
                </div>

                <p [innerHTML]="descStr" class="description"></p>
            </div>

            <div class="col-sm-6">
                <div class="product-detail">
                    <form [formGroup]="createSetUpForm" style="margin-left: 1%;">
                        <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div">
                            <mat-card class="contain_card mat-card_style2">
                                <mat-form-field class="example-full-width" style="width: 100%">
                                    <input matInput placeholder="Price/{{ selectedProduct.product_Unit }}"
                                        formControlName="productPrice"
                                        [value]="createSetUpForm.get('productPrice').value | number: '1.2-2'" readonly
                                        style="text-align: left; padding-bottom: 2%" />
                                </mat-form-field>
                            </mat-card>

                            <mat-card class="contain_card mat-card_style2">
                                <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                                    <input matInput type="number"
                                        placeholder="Quantity/{{selectedProduct.product_Unit}}" type="number"
                                        formControlName="qty" (focusout)="onQtySelect($event)"
                                        style="text-align: left" />
                                </mat-form-field>
                            </mat-card>
                        </div>

                        <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div" *ngIf="showComposition">
                            <mat-card class="contain_card mat-card_style2">
                                <mat-form-field class="selectOption" style="width: 100%" visivility="none">
                                    <mat-select placeholder="Flavour" (selectionChange)="onFlavourSelect($event.value)"
                                        formControlName="composition">
                                        <mat-option style="text-align: left; padding-bottom: 2%"
                                            *ngFor="let composition of productCompositionList"
                                            [value]="composition.refNo">
                                            {{ composition.compositionName }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </mat-card>

                            <mat-card class="contain_card mat-card_style2">
                                <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                                    <input matInput placeholder="Flavour Premium Price"
                                        formControlName="premiumFlavourPrice"
                                        [value]="createSetUpForm.get('premiumFlavourPrice').value | number: '1.2-2'"
                                        readonly style="text-align: left; padding-bottom: 2%" />
                                </mat-form-field>
                            </mat-card>
                        </div>

                        <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div">
                            <mat-card *ngIf="showColor" class="contain_card"
                                [ngClass]="showShape || showDimension ? 'mat-card_style2': 'mat-card_style'">
                                <mat-form-field class="selectOption" style="width: 100%" visivility="none">
                                    <mat-select placeholder="Color" formControlName="color">
                                        <mat-option style="text-align: left; padding-bottom: 2%"
                                            *ngFor="let color of productColorList" [value]="color.refCode">
                                            {{ color.colorName }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </mat-card>

                            <mat-card *ngIf="showShape" class="contain_card"
                                [ngClass]="showColor || showDimension ? 'mat-card_style2': 'mat-card_style'">
                                <mat-form-field class="selectOption" style="width: 100%" visivility="none">
                                    <mat-select placeholder="Shape" formControlName="shape">
                                        <mat-option style="text-align: left; padding-bottom: 2%"
                                            *ngFor="let shape of productShapeList" [value]="shape.refNo">
                                            {{ shape.productShape }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </mat-card>

                            <mat-card *ngIf="showDimension" class="contain_card"
                                [ngClass]="(showColor && showShape) || (!showColor && !showShape) ? 'mat-card_style': 'mat-card_style2'">
                                <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                                    <input matInput placeholder="Dimension" formControlName="dimension"
                                        style="text-align: left; padding-bottom: 2%" />
                                </mat-form-field>
                            </mat-card>
                        </div>

                        <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div">
                            <mat-card class="contain_card mat-card_style2">
                                <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                                    <input matInput placeholder="Delivery Date" [matDatepicker]="licker1"
                                        [min]="todayDate" [max]="maxDate" formControlName="deliveryDate"
                                        (click)="licker1.open()" (dateChange)="dateChanged()"
                                        style="text-align: left; padding-bottom: 2%" readonly />
                                    <mat-datepicker-toggle matSuffix [for]="licker1"></mat-datepicker-toggle>
                                    <mat-datepicker #licker1 disabled="false"></mat-datepicker>
                                </mat-form-field>
                            </mat-card>

                            <mat-card class="contain_card mat-card_style2">
                                <mat-form-field class="selectOption" style="width: 100%" visivility="none">
                                    <mat-select placeholder="Delivery Time Slot" formControlName="deliveryTime">
                                        <mat-option style="text-align: left; padding-bottom: 2%"
                                            *ngFor="let slot of timeSlotAvl" [value]="slot">
                                            {{ slot }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </mat-card>
                        </div>

                        <div *ngIf="selectedCategory != 'photoFrames'" fxLayout="column" class="flex_div_nowrap">
                            <!-- Top Message -->
                            <mat-card class="contain_card mat-card_style">
                                <mat-form-field class="example-full-width">
                                    <input matInput placeholder="Top Message" maxlength="17"
                                        formControlName="noteTop" />
                                    <span matSuffix class="text_hint">
                                        {{ createSetUpForm.get('noteTop')?.value?.length || 0 }}/17
                                    </span>
                                </mat-form-field>
                            </mat-card>

                            <!-- Center Message -->
                            <mat-card class="contain_card mat-card_style">
                                <mat-form-field class="example-full-width">
                                    <input matInput placeholder="Center Message" maxlength="12"
                                        formControlName="noteCenter" />
                                    <span matSuffix class="text_hint">
                                        {{ createSetUpForm.get('noteCenter')?.value?.length || 0 }}/12
                                    </span>
                                </mat-form-field>
                            </mat-card>

                            <!-- Bottom Message -->
                            <mat-card class="contain_card mat-card_style">
                                <mat-form-field class="example-full-width">
                                    <input matInput placeholder="Bottom Message" maxlength="17"
                                        formControlName="noteBottom" />
                                    <span matSuffix class="text_hint">
                                        {{ createSetUpForm.get('noteBottom')?.value?.length || 0 }}/17
                                    </span>
                                </mat-form-field>
                            </mat-card>
                        </div>


                        <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div">
                            <mat-card class="contain_card mat-card_style">
                                <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                                    <!-- <mat-label>SubTotal</mat-label> -->
                                    <input matInput placeholder="SubTotal" formControlName="subTotal"
                                        [value]="createSetUpForm.get('subTotal').value | number: '1.2-2'"
                                        style="text-align: left; padding-bottom: 2%" readonly />
                                </mat-form-field>
                            </mat-card>
                        </div>

                        <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div">
                            <mat-card class="contain_card mat-card_style"
                                style="height: 90px;display: flex;overflow: auto;">
                                <div *ngFor="let file of fileInputs; let i = index" class="fileData_div">
                                    <span class="span_with_file">
                                        <img [src]="getFileData('fileImage' + i)" alt="Picture"
                                            *ngIf="getFileData('fileImage' + i)" class="image_size" />

                                        <mat-icon *ngIf="!getFileData('fileImage' + i)" class="file_icon_size">
                                            image
                                        </mat-icon>
                                    </span>
                                    <input type="file" readonly
                                        (change)="onChangeUploadFile($event, 'fileImage' + i, 'image' + i)"
                                        accept=".jpg,.jpeg,.png,.webp" (click)="$any($event.target).value=null"
                                        class="hidden-file-input" [id]="'image' + i">

                                    <button class="custom-file-button" (click)="triggerFileInput('image' + i)">
                                        Choose File
                                    </button>

                                    <mat-icon class="cancel_icon_for_remove" *ngIf="getFileData('fileImage' + i)"
                                        (click)="onRemoveFileClick('fileImage' + i, 'image' + i);">
                                        clear
                                    </mat-icon>
                                </div>
                            </mat-card>
                            <div class="file-format-note">
                                Only JPG, JPEG, PNG, WEBP formats are accepted. (Max 10MB)
                            </div>
                        </div>

                        <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div_btn">
                            <button type="button" class="btn btn-primary bg-pink"
                                (click)="addToCart(selectedProduct, false)">
                                Add to Cart
                            </button>
                            <button type="button" class="btn btn-primary bg-pink"
                                (click)="addToCart(selectedProduct, true)">
                                Buy Now
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Custom Cakes Section -->
<div class="custom_cake_div" *ngIf="selectedCategory && selectedCategory == 'customCakes' && deliveryType">
    <!-- Product Details Section -->
    <form [formGroup]="createSetUpFormCustomCake">
        <div formArrayName="cakes">
            <div class="container custom_container" *ngFor="let cake of cakes.controls; let i=index"
                [formGroupName]="i">
                <div class="col-sm-4">
                    <div class="custom_product_image">
                        <div class="view hm-zoom z-depth-2" id="img_div_align_custom">
                            <img [src]="getFileDataCustomCake('fileImage',i)" alt="Picture"
                                *ngIf="getFileDataCustomCake('fileImage',i) && !checkCustomRefNo(i)"
                                alt="Image not found" style="height: 100%" class="img-fluid rounded"
                                onerror="this.src='../../../../assets/img/defaultCake.webp';" />
                            <img [src]="cake.value.selectedImageEdit" alt="Picture" *ngIf="checkCustomRefNo(i)"
                                alt="Image not found" style="height: 100%" class="img-fluid rounded"
                                onerror="this.src='../../../../assets/img/defaultCake.webp';" />
                            <span style="position: absolute;top: 6%;right: 5%;">

                            </span>
                            <mat-icon *ngIf="!getFileDataCustomCake('fileImage',i)" class="file_icon_size_custom">
                                image
                            </mat-icon>
                        </div>
                    </div>

                    <div class="terms_div">
                        <label class="checkbox">
                            <input type="checkbox" style="height: 20px; width: 15px" formControlName="isAgreedTerms" />
                            I hereby certify that the uploaded image is not religious, derogatory, or objectionable.
                        </label>
                    </div>

                    <div class="file_select_div">
                        <input type="file" *ngIf="!checkCustomRefNo(i)" readonly
                            (change)="onChangeUploadFileCustomCake($event, 'fileImage', 'image',i)"
                            accept=".jpg,.jpeg,.png,.webp" (click)="onFileInputClick($event, i)" class="input_file_size"
                            [id]="'image'">

                        <input matInput type="text" *ngIf="checkCustomRefNo(i)" formControlName="fileImage" readonly>

                        <mat-icon class="cancel_icon_custom"
                            *ngIf="getFileDataCustomCake('fileImage',i) && !checkCustomRefNo(i)"
                            (click)="onRemoveFileClickCustomCake('fileImage', 'image',i);">
                            clear
                        </mat-icon>
                    </div>
                    <div class="file-format-note">
                        Only JPG, JPEG, PNG, WEBP formats are accepted. (Max 10MB)
                    </div>
                    <h1 class="mbr-section-title h2_font_size"></h1>
                </div>

                <div class="col-sm-6 product_div">
                    <div class="product-detail">
                        <div style="margin-left: 1%;">
                            <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div">
                                <mat-card class="contain_card mat-card_style3">
                                    <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                                        <input matInput type="number" placeholder="Quantity" type="number"
                                            formControlName="requestedQty" style="text-align: left" />
                                    </mat-form-field>
                                </mat-card>

                                <mat-card class=" contain_card mat-card_style3">
                                    <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                                        <input matInput placeholder="Delivery Date" [matDatepicker]="licker2"
                                            [min]="todayDate" [max]="maxDate" formControlName="requestedDeliveryDate"
                                            (click)="licker2.open()" (dateChange)="customDateChanged(i,'Requested')"
                                            style="text-align: left; padding-bottom: 2%" readonly />
                                        <mat-datepicker-toggle matSuffix [for]="licker2"></mat-datepicker-toggle>
                                        <mat-datepicker #licker2 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </mat-card>

                                <mat-card class="contain_card mat-card_style3">
                                    <mat-form-field class="selectOption" style="width: 100%" visivility="none">
                                        <mat-select placeholder="Delivery Time Slot"
                                            formControlName="requestedDeliveryTime">
                                            <mat-option style="text-align: left; padding-bottom: 2%"
                                                *ngFor="let slot of cake.value.requestedSlots" [value]="slot">
                                                {{ slot }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </mat-card>
                            </div>

                            <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div" *ngIf="showComposition">
                                <mat-card class="contain_card mat-card_style2">
                                    <mat-form-field class="selectOption" style="width: 100%" visivility="none">
                                        <mat-select placeholder="Flavour"
                                            (selectionChange)="onCustomFlavourSelect($event.value,i)"
                                            formControlName="composition">
                                            <mat-option style="text-align: left; padding-bottom: 2%"
                                                *ngFor="let composition of productCompositionList"
                                                [value]="composition.refNo">
                                                {{ composition.compositionName }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </mat-card>

                                <mat-card class="contain_card mat-card_style2">
                                    <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                                        <input matInput placeholder="Flavour Premium Price"
                                            formControlName="premiumFlavourPrice" readonly
                                            style="text-align: left; padding-bottom: 2%" />
                                    </mat-form-field>
                                </mat-card>
                            </div>

                            <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div">
                                <mat-card class="contain_card mat-card_style">
                                    <mat-form-field class="example-full-width" style="width: 90%" visivility="none">
                                        <input matInput #input placeholder="Message/Note On Cake" maxlength="40"
                                            formControlName="note" style="text-align: left"
                                            [readonly]="cake.value.refNo" />
                                    </mat-form-field>
                                    <mat-hint style="font-size: 10px;">{{ input.value?.length || 0 }}/40</mat-hint>
                                </mat-card>
                            </div>

                            <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div_btn">
                                <button type="button" class="btn btn-primary bg-pink-custom"
                                    *ngIf="!checkCustomRefNo(i)" (click)="openDeliveryTypeDialogForCheckPrice(i)">
                                    Check Price & Delivery Date
                                </button>

                                <button type="button" class="btn btn-primary bg-pink-custom"
                                    *ngIf="checkCustomRefNo(i) && cake.value.status == 'Requested'"
                                    (click)="getCustomCakeByRefNo(i)">
                                    Get Price & Delivery Date
                                </button>

                                <button type="button" class="btn btn-primary bg-pink-custom"
                                    *ngIf="checkCustomRefNo(i) && cake.value.status != 'Requested'">
                                    Approved status
                                </button>
                            </div>

                            <div *ngIf="cake.value.status && cake.value.status != 'Requested'" fxLayout="row"
                                fxLayout.lt-sm="column" class="flex_div">
                                <mat-card class="contain_card mat-card_style3">
                                    <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                                        <input matInput type="number" placeholder="Minimum Quantity" type="number"
                                            formControlName="responseQty" (focusout)="onResponseQtySelect($event,i)"
                                            style="text-align: left" />
                                    </mat-form-field>
                                </mat-card>

                                <mat-card class="contain_card mat-card_style3">
                                    <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                                        <input matInput placeholder="Expected Delivery Date" [matDatepicker]="licker2"
                                            [min]="todayDate" [max]="maxDate" formControlName="responseDeliveryDate"
                                            (dateChange)="customDateChanged(i,'Response')"
                                            style="text-align: left; padding-bottom: 2%" />
                                        <mat-datepicker-toggle matSuffix [for]="licker2"></mat-datepicker-toggle>
                                        <mat-datepicker #licker2 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </mat-card>

                                <mat-card class="contain_card mat-card_style3">
                                    <mat-form-field class="selectOption" style="width: 100%" visivility="none">
                                        <mat-select placeholder="Delivery Time Slot"
                                            formControlName="responseDeliveryTime">
                                            <mat-option style="text-align: left; padding-bottom: 2%"
                                                *ngFor="let slot of cake.value.responseSlots" [value]="slot">
                                                {{ slot }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </mat-card>
                            </div>

                            <div *ngIf="cake.value.status && cake.value.status != 'Requested'" fxLayout="row"
                                fxLayout.lt-sm="column" class="flex_div">
                                <mat-card class="contain_card mat-card_style3">
                                    <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                                        <input matInput placeholder="Rate" formControlName="rate"
                                            style="text-align: left; padding-bottom: 2%" readonly />
                                    </mat-form-field>
                                </mat-card>

                                <mat-card class="contain_card mat-card_style3">
                                    <mat-form-field class="example-full-width" style="width: 100%" visivility="none">
                                        <input matInput placeholder="Amount" formControlName="totalAmount"
                                            style="text-align: left; padding-bottom: 2%" readonly />
                                    </mat-form-field>
                                </mat-card>

                                <button type="button" *ngIf="cake.value.status == 'Resolved'"
                                    class="btn btn-primary accept_btn" (click)="openDeliveryTypeDialogForCheckPrice(i)">
                                    Accept
                                </button>

                                <button type="button" *ngIf="cake.value.status == 'Accepted'"
                                    class="btn btn-primary accept_btn">
                                    Accepted
                                </button>

                                <button type="button" *ngIf="cake.value.status == 'Declined'"
                                    class="btn btn-primary accept_btn" style="background-color: red;">
                                    Declined
                                </button>
                            </div>

                            <div *ngIf="cake.value.status == 'Accepted'"
                                style="display: flex;justify-content: center;align-items: center;">
                                <div fxLayout="row" fxLayout.lt-sm="column" class="flex_div_btn" style="width: 90%;">
                                    <button type="button" class="btn btn-primary bg-pink"
                                        (click)="addToCartCustomCake(i, false)">
                                        Add to Cart
                                    </button>
                                    <button type="button" class="btn btn-primary bg-pink"
                                        (click)="addToCartCustomCake(i, true)">
                                        Buy Now
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <button mat-fab color="primary" class="fab-button-delete" (click)="deleteCustomCake(i)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="add-cake-button">
            <button mat-fab color="primary" class="fab-button" (click)="addCake()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </form>
</div>
<canvas #canvasRenderer style="display: none;"></canvas>